/** Nitesh Saini
 * © All rights reserved
 */

import axios from 'axios';
import { useSelector } from 'react-redux';
import {store} from '../index';
console.log(store?.getState()?.userInfo,"store.........")
console.log()
// export const BASE_URL = 'http://localhost:5000/api/enacts/user';
export const BASE_URL = 'https://fbb9gq3zbs.us-east-1.awsapprunner.com/api/enacts/user';
export const request = async (
    url,
    options,
    isHeader = true,
    authHeader,
    isMultiPartFormData = false,
) => {
    const client = axios.create({
        baseURL: BASE_URL + url,
        headers: {
            Authorization: authHeader,
            accept: 'application/json',
            'Content-Type': isMultiPartFormData
                ? 'multipart/form-data'
                : 'application/json',
        },
    });

    return client(options);
};
